import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";
import { ETheme, FluentProvider } from "@/dependencies";
import {
  makeStyles,
  MenuButton,
  MenuButtonProps,
  mergeClasses
} from "@fluentui/react-components";

interface MenuButtonCustomProps {
  rcName?: ETheme;
  theme?: string;
  rcRole?: string[];
  requireRoles?: string[];
  isIconMenuButton?: boolean;
}

const useStyles = makeStyles({
  root: {
    minWidth: "80px",
    fontWeight: "normal",
    //padding: "0px 8px"
  },
  root2: {
    minWidth: "10px",
  },
});

const MenuButtonCustom = (props: MenuButtonCustomProps & MenuButtonProps) => {
  const styles = useStyles();
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles,
  );
 
  return isCanBeVisible ? (
    props.theme ? (
      <FluentProvider
        theme={
          props.theme
        }
      >
        <MenuButton
          {...props}
          className={mergeClasses(styles.root, props.className)}
        />
      </FluentProvider>
    ) : (
      <MenuButton
        {...props}
        className={mergeClasses(styles.root, props.className)}
      />
    )
  ) : null;
};

export default MenuButtonCustom;
